import React from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import ActionBarCounts from './counts';
import ActionBarStatus from './status';
import ActionBarBulkActions from './actions';

const IndexActionBar = props => {
  const isCustomButton = React.isValidElement(props.buttons);

  const styleName = classNames('Index-toolbar', {
    'Index-toolbar--secondary': true,
    'Index-toolbar--success': props.success,
    'Index-toolbar--danger': props.hasError,
  });

  const clearFiltersButton = (
    <button
      tabIndex="0"
      type="button"
      key="clear"
      className="IndexFilter-clearFiltersButton NewButton NewButton--center NewButton--small IndexFilter-actionButton mr-12"
      onClick={props.clearFilter}
    >
      <span className="c-brand-gray-darkest">{t('common.clear_filters')}</span>
    </button>
  );

  const renderStatus = () => {
    const components = [<ActionBarCounts key="count" {...props} />];
    if (props.loading || props.hasError) return <ActionBarStatus {...props} />;
    if (props.filterIsActive) components.unshift(clearFiltersButton);
    return components;
  };

  const actions = isCustomButton ? (
    props.buttons
  ) : (
    <ActionBarBulkActions {...props} />
  );

  return (
    <CSSTransition
      in={props.visible}
      classNames="Index-toolbar--secondary"
      timeout={300}
      unmountOnExit
    >
      <div className={styleName}>
        {props.children}
        {renderStatus()}
        {!props.disabled && (props.success || !props.hasError) && actions}
      </div>
    </CSSTransition>
  );
};

export default IndexActionBar;
